import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 26.957 26.957" {...props}>
    <g id="Group_171" data-name="Group 171">
      <g id="Path_701" data-name="Path 701">
        <path d="M22.393,10.0075a.77.77,0,0,1-.5391-1.32l2.9016-2.8427L21.8539,3.0018a.77.77,0,1,1,1.0782-1.1L26.957,5.8444l-4.0249,3.943A.768.768,0,0,1,22.393,10.0075Z" />
      </g>
      <g id="Path_702" data-name="Path 702">
        <path d="M22.393,25.2756a.77.77,0,0,1-.5391-1.32l2.9016-2.8427L21.8539,18.27a.77.77,0,1,1,1.0782-1.1l4.0249,3.9429-4.0249,3.943A.768.768,0,0,1,22.393,25.2756Z" />
      </g>
      <g id="Group_169" data-name="Group 169">
        <g id="Line_12" data-name="Line 12">
          <path d="M25.366,21.8825H20.2767a.77.77,0,1,1,0-1.5405H25.366a.77.77,0,1,1,0,1.5405Z" />
        </g>
        <g id="Line_13" data-name="Line 13">
          <path d="M16.5045,20.188A.7693.7693,0,0,1,15.88,19.87l-1.79-2.4686a.77.77,0,1,1,1.2472-.9041l1.79,2.4685a.77.77,0,0,1-.6228,1.2224Z" />
        </g>
        <g id="Line_14" data-name="Line 14">
          <path d="M14.7142,17.7194a.769.769,0,0,1-.6211-.3141l-1.0985-1.4947a.77.77,0,1,1,1.2411-.9122l1.0986,1.4946a.77.77,0,0,1-.62,1.2264Z" />
        </g>
        <g id="Path_703" data-name="Path 703">
          <path d="M13.6162,16.2245a.769.769,0,0,1-.63-.3267,3.8918,3.8918,0,0,0-3.1782-1.6487H9.8031a.77.77,0,0,1-.0008-1.54h.0053a5.4332,5.4332,0,0,1,4.4374,2.302.77.77,0,0,1-.6288,1.2139Z" />
        </g>
        <g id="Path_704" data-name="Path 704">
          <path d="M20.0971,21.8833a5.4108,5.4108,0,0,1-4.1879-1.9746.77.77,0,1,1,1.1885-.98,3.8748,3.8748,0,0,0,2.9994,1.4144h.0043a.77.77,0,0,1,.0008,1.5406Z" />
        </g>
      </g>
      <g id="Group_170" data-name="Group 170">
        <g id="Line_15" data-name="Line 15">
          <path d="M25.3658,6.6147H20.2764a.77.77,0,1,1,0-1.54h5.0894a.77.77,0,1,1,0,1.54Z" />
        </g>
        <g id="Line_16" data-name="Line 16">
          <path d="M13.6169,12.2728a.77.77,0,0,1-.6218-1.2237l2.8858-3.963a.77.77,0,0,1,1.2452.9067L14.24,11.9558A.7691.7691,0,0,1,13.6169,12.2728Z" />
        </g>
        <g id="Path_705" data-name="Path 705">
          <path d="M9.8076,14.2484H9.8048a.77.77,0,0,1,.0005-1.5406h.0023a3.8937,3.8937,0,0,0,3.1807-1.65.77.77,0,1,1,1.26.8871A5.4367,5.4367,0,0,1,9.8076,14.2484Z" />
        </g>
        <g id="Path_706" data-name="Path 706">
          <path d="M16.5027,8.31a.77.77,0,0,1-.594-1.26,5.4089,5.4089,0,0,1,4.1882-1.9751h.005a.77.77,0,0,1-.0007,1.54h-.0043a3.873,3.873,0,0,0-2.9992,1.4145A.769.769,0,0,1,16.5027,8.31Z" />
        </g>
      </g>
      <g id="Line_17" data-name="Line 17">
        <path d="M11.7968,14.2486H.77a.77.77,0,1,1,0-1.54H11.7968a.77.77,0,0,1,0,1.54Z" />
      </g>
    </g>
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/FlowBuilder.jsx